import nxModule from 'nxModule';

const templateUrl = require('./users-branches.template.html');

nxModule.component('usersBranches', {
  template: '<users-list></users-list>',
  controller: function () {

  }
});
